import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getTotalRequestReschedule = async (query) => {
  const { data } = await SigliveServiceV1({
    method: 'GET',
    url: `productivity-host/total-request-reschedule?${query}`,
  });

  return data?.data;
};

export default getTotalRequestReschedule;
